import React from 'react'
import { useNavigate } from 'react-router-dom'
import WTPMasterCard from './WTPMasterCard'

export default function WTPMasterCardManage(props) {

    const { Countdata,HeaderMonthID,HeaderFinancialYear , MonthValue, YearValue , YearLabel,MonthLabel,WardValue,WardLabel,ProjectTypeId,DashboardName,DashProjectTypeId,WTPMasterCountData } = props
  
    const MasterNavigate = (name, screenFlag) => {
        if (name === "Pump Master") {
            navigate(`/wtppumpmasterpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Equipment Master") {
            navigate(`/wtpequipmentmasterpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Bed Master") {
            navigate(`/wtpbednumbermasterpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Work Master") {
            navigate(`/wtpworkmasterpage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        }
    }
    const navigate = useNavigate()

    return (
        <div>
            <div className="row">
                <h5 className="ml-4 py-2">Master</h5>
            </div>

            <div className='row pr-3 pl-3'>
                <div className='col-12 col-md-6 col-lg-3'>
                    <WTPMasterCard
                        title="Pump Master"
                        cardName='py-2 green cursor'
                        masterCard='card-body mastercardborderpink'
                        // count={MasterCountData?.PipeLineTotalCount}
                        count={WTPMasterCountData?.PumpMasterTotalCount ? WTPMasterCountData?.PumpMasterTotalCount : '0'}
                        imgPath="./assets/img/pipeline.png"
                        // navLink='/pipelinemasterpage'
                        MasterNavigate={MasterNavigate}
                        color='red'
                    />
                </div>
                <div className='col-12 col-md-6 col-lg-3'>
                    <WTPMasterCard
                        title="Equipment Master"
                        cardName='py-2 blue cursor'
                        masterCard='card-body mastercardborderblue'
                        // count={MasterCountData?.PumpStationTotalCount}
                        count={WTPMasterCountData?.EquipmentMasterTotalCount ? WTPMasterCountData?.EquipmentMasterTotalCount : '0'}
                        imgPath="./assets/img/equipment.png"
                        // navLink='/pumpingstationmasterpage'
                        MasterNavigate={MasterNavigate}
                        color='blue'
                    />
                </div>

                <div className='col-12 col-md-6 col-lg-3'>
                    <WTPMasterCard
                        title="Bed Master"
                        cardName='py-2 green cursor'
                        masterCard='card-body mastercardborderpink'
                        // count={Countdata.WorkTypeTotalCount}
                        count={WTPMasterCountData?.BedMasterTotalCount ? WTPMasterCountData?.BedMasterTotalCount : '0'}
                        imgPath="./assets/img/ward (2).png"
                        // navLink='/workmasterpage'
                        MasterNavigate={MasterNavigate}
                        color='red'
                    />
                </div>

                <div className='col-12 col-md-6 col-lg-3'>
                    <WTPMasterCard
                        title="Work Master"
                        cardName='py-2 blue cursor'
                        masterCard='card-body mastercardborderblue'
                        // count={Countdata.PipelineDetailsTotalCount}
                        count={WTPMasterCountData?.WorkMasterTotalCount ? WTPMasterCountData?.WorkMasterTotalCount : '0'}
                        imgPath="./assets/img/data-processing.png"
                        // navLink='/contractorwisewardname'
                        MasterNavigate={MasterNavigate}
                        color='blue'
                    />
                </div>

            </div>

        </div>


    )

}

